/**
 * Created by Mark on 17/04/2017.
 */

import BaseStore from './base-store.js';
import React from 'react';
import Constants from  '../constants.js'


class SongsAndStoriesStore extends BaseStore {

    constructor(){
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.plans = [];
    }


    _registerToActions(action) {

        switch(action.actionType)
        {
            case Constants.ALL_SONG_AND_STORIES_UPDATE :
                this.media = action.response;
                this.emitChange();
                break;
        }
    }

    getAll(){
        return this.media
    }
}

export default new SongsAndStoriesStore();